import React from "react";
import "./CoreVirtuesValuesWhite.css";
import senses from "../../assets/senses.png";
import changes from "../../assets/changes.png";
import trust from "../../assets/trust.png";
import { useTranslation } from "react-i18next";

const CoreVirtuesValues = () => {
  const { t } = useTranslation("global");

  return (
    <>
      <div className="core-heading2">
        <h1>{t("coreVirtuesValues.heading")}</h1>
        <h6>{t("coreVirtuesValues.subheading")}</h6>
      </div>
      <div className="core-virtues-container2">
        <div className="core-virtues-item2">
          <img src={senses} alt="senses" />
          <h2>{t("coreVirtuesValues.senseOfOwnership.title")}</h2>
          <p>{t("coreVirtuesValues.senseOfOwnership.description")}</p>
        </div>

        <div className="core-virtues-item2">
          <img src={changes} alt="changes" />
          <h2>{t("coreVirtuesValues.constantChanges.title")}</h2>
          <p>{t("coreVirtuesValues.constantChanges.description")}</p>
        </div>

        <div className="core-virtues-item2">
          <img src={trust} alt="trust" />
          <h2>{t("coreVirtuesValues.trust.title")}</h2>
          <p>{t("coreVirtuesValues.trust.description")}</p>
        </div>
      </div>
    </>
  );
};

export default CoreVirtuesValues;
